import { Link } from 'react-router-dom';
import SwipeOpinionLogo from './brand/SwipeOpinionLogo';

export default function Footer() {
  return (
    <footer className="border-t border-[#E5E7EB] bg-white mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <SwipeOpinionLogo variant="mono" monoColor="gray" markClassName="w-4 h-4" wordmarkClassName="text-sm font-semibold text-[#6B7280]" />

          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-[#6B7280]">
            <Link to="/terms" className="hover:text-[#5B4FE8] transition-colors">
              Terms &amp; Conditions
            </Link>
            <Link to="/privacy" className="hover:text-[#5B4FE8] transition-colors">
              Privacy Policy
            </Link>
            <a href="mailto:support@swipeopinion.com" className="hover:text-[#5B4FE8] transition-colors">
              Contact
            </a>
            <Link to="/sms-terms" className="hover:text-[#5B4FE8] transition-colors">
              SMS Terms
            </Link>
          </nav>

          <p className="text-xs text-[#6B7280]">&copy; 2026 Swipe Opinion. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
